import React from "react";

const Email: React.FC = () => (
<svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.625 11.25L22.5 26.25L39.375 11.25" stroke="white"/>
<rect x="3.75" y="9.375" width="37.5" height="26.25" rx="6" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

export default Email;
